<template>
	<div class="long_row learner_explore_program">

		<div class="row">
			<div class="col-12">
				<div class="sec_tp_msg ace_sec">
					<span>{{exploreProgramText}} {{exploreProgramsLabelPlural}}</span>
				</div>
			</div>
		</div>

    <div class="row">
      <div v-for="(pg, i) in explorePrograms" class="col-6 explore_intro">
        <div class="pkg_entity_bx programs">
          <button @click.stop="goToProgramGuideDetail(pg)" class="ace_sec" :aria-label="'program ' + pg.title">
						<span class="bx_inner">
	            <span class="thumbnail_container">
	              <div class="default_thumb thumbnail_img" v-if="pg.thumbnailURL" :class="setImageBgColor(pg.thumbnailURL)">
	                <img v-bind:src="pg.thumbnailURL" alt="Img">
	              </div>
	              <div v-else class="default_thumbnail">
	                <span class="ic ic-degreeProgram"></span>
	              </div>
	              <span class="entity_title" :id="'programGuideTitle_' + i">
	                <v-clamp autoresize :max-lines="2">{{ pg.title }}</v-clamp>
	              </span>

								<b-popover :target="'programGuideTitle_' + i" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + i">
									<div class="title_container">
										{{ pg.title }}
									</div>
								</b-popover>
								<div :id="'entityNameContainer_' + i" class="title_container_popup"></div>

	            </span>
						</span>
          </button>
        </div>
      </div>
      <div class="col-6 explore_intro explore_more">
        <div class="pkg_entity_bx programs">
          <button @click="exploreProgramsClicked" class="ace_sec">
            <span class="bx_inner">
              <span class="thumbnail_container">
                <div class="default_thumbnail">
                  <span class="ic ic-degreeProgram"></span>
                </div>
              </span>
              <span class="entity_title pg-title">
                <span>Explore<br />{{programShortNameLabelPlural}} </span>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-2 sec_msg">
      <div class="col-12 ace_sec">
        <span>If you want to look at careers click</span>
        <span><a href="javascript://" @click="exploreCareersClicked">explore careers.</a></span>
      </div>
    </div>
	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import VClamp from 'vue-clamp'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

	export default {
		name: 'learner-explore-programs',
		components: {
      VClamp
    },
		data: () => {
			return {
        explorePrograms: [],
				exploreProgramText: 'Check out our '
			}
		},
    created () {
      this.populateLearnerDashboradPrograms()
    },
    beforeMount () {
      this.$root.$on('reloadLearnerDashboard', () => {
        this.populateLearnerDashboradPrograms()
      })
    },
		methods: {
			...mapActions([
	      'loadLearnerExplorePrograms'
	    ]),
      populateLearnerDashboradPrograms () {
        this.loadLearnerExplorePrograms().then(resp => {
          this.explorePrograms = resp
        })
      },
      exploreProgramsClicked () {
        return this.$router.push({name: 'exploreProgramResults'})
      },
      exploreCareersClicked () {
        return this.$router.push({name: 'exploreCareerResults'})
      },
      setImageBgColor (imageURL) {
        let getImageURL = imageURL.split('/')
        let getImageName = getImageURL[getImageURL.length - 1].match(/(.*)\.[\w]+$/)[1]
        return getImageName.replace(/\./g, '__')
      },
      goToProgramGuideDetail (programGuide) {
        let routerParams = {
          cipCode: programGuide.cipCode,
          programGuideCode: programGuide.code,
          type: programGuide.type
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams, query: {returnTo: 'learnerDashboard', pageTitle: 'Back To Learner Dahsboard'}})
      },
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getExploreSearchPackage(packages)
      }
		},
    computed: {
      ...mapState({
        'packages': state => state.dashboard.packages,
        'enabledFeatures': state => state.dashboard.enabledFeatures,
      }),
      exploreProgramsFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      exploreProgramsLabelPlural () {
        let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
        if (exploreFeature && exploreFeature.label) {
          return exploreFeature.label + 's'
        }
        return 'programs'
      },
      programShortNameLabelPlural () {
        let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
        if (exploreFeature) {
          for (var i = 0; i < exploreFeature.flags.length; i++) {
            if (exploreFeature.flags[i].title === 'useProgramShortText') {
              if (exploreFeature.flags[i].isEnabled) {
                return exploreFeature.flags[i].label + 's'
              }
            }
          }
        }
        return 'programs'
      }
    }
	}
</script>

<style scoped>
  .program-thumbnail {
    padding-top: 0px;
  }

  .pg-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px !important;
  }

  .explore-pg {
    margin: 0 !important;
    border-bottom: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerExplorePrograms.vue